import { useGet } from 'hooks/use-get';
import React, { useContext, useMemo } from 'react';
import { getTreatments } from '../../self-service/features/treatment-catalog/api/get-treatments';

import { useAccountState } from 'contexts/account/account-context';
import { Treatment } from 'views/self-service/features/treatment-catalog/types/treatment.type';

type State = {
  isLoading: boolean;
  treatmentCodes: string[];
  treatments: Treatment[] | undefined;
};

const TreatmentContext = React.createContext<State | undefined>(undefined);

type TreatmentProviderProps = {
  children: React.ReactNode;
};

const TreatmentProvider: React.FC<TreatmentProviderProps> = ({ children }) => {
  const { account } = useAccountState();

  const { data: treatments, isLoading } = useGet(['getTreatments'], () => getTreatments(String(account.company!.companyId)), {
    enabled: !!account.company!.companyId,
  });

  const treatmentCodes = useMemo(() => treatments?.map((treatment) => treatment.code) ?? [], [treatments]);

  return (
    <TreatmentContext.Provider value={{ treatmentCodes, treatments, isLoading }}>{children}</TreatmentContext.Provider>
  );
};

function useTreatmentState() {
  const context = useContext(TreatmentContext);
  if (context === undefined) {
    throw new Error('useTreatmentState must be used within a Treatment provider');
  }
  return context;
}

export { TreatmentProvider, useTreatmentState };
